import { Vector3 } from 'three';

export const PROJECTIONS_SETTINGS = {
  top: {
    azimuth: -Math.PI / 2,
    polarAngle: -Math.PI / 2,
  },
  left: {
    azimuth: -Math.PI / 2,
    polarAngle: Math.PI / 2,
  },
  right: {
    azimuth: Math.PI / 2,
    polarAngle: Math.PI / 2,
  },
  back: {
    azimuth: 0,
    polarAngle: Math.PI / 2,
  },
  front: {
    azimuth: Math.PI,
    polarAngle: Math.PI / 2,
  },
};

export const DEFAULT_DIRECTIONAL_VECTOR = new Vector3(-Math.PI / 2, 0.7, 0);
